"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_ACCESS_CONTROL = exports.LOAD_ACCESS_CONTROL = void 0;
var LOAD_ACCESS_CONTROL = {
  matchesSomeScopes: ['lead-flows-access', 'collected-forms-access']
};
exports.LOAD_ACCESS_CONTROL = LOAD_ACCESS_CONTROL;
var UPDATE_ACCESS_CONTROL = {
  matchesSomeScopes: ['lead-flows-access', 'collected-forms-access']
};
exports.UPDATE_ACCESS_CONTROL = UPDATE_ACCESS_CONTROL;